<template>
  <div>
    <div id="card">
      <div style="background-color: #fff; margin-bottom: 10px; box-shadow: 1px 1px 1px 1px rgba(20%, 20%, 20%, 0.1); padding-bottom: 10px;">
        <template>
          <el-table :data="shopData"
            :height="shopHeight"
            style="position: fixed; top: 23px; padding-right: 10px;">
            <el-table-column width="100">
              <template slot-scope="scope">
                <div :style="{ overflow: 'hidden', width: `${90}px`, height: `${90}px`, backgroundImage: 'url(' + scope.row.imageUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center' }"></div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <div style="font-weight: 500;">{{ scope.row.title }}</div>
                <div style="font-weight: 400; font-size: 13px;">可兌換次數: <span style="color: black; font-weight: 500;">{{ scope.row.redeem === '2' ? restTime(scope.row.title, scope.row.maxRedeem) : '-' }}</span></div>
                <el-tag v-if="allowExchange(scope.row.point) || requiredExp(scope.row.level) > nowExp || outofUsage(scope.row) || notInTags(scope.row.specificTag)" type="danger" size="mini">無法兌換</el-tag>
                <el-tag v-else type="success" size="mini">可兌換</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="100">
              <template slot-scope="scope">
                <el-button type="primary" @click="openInfo(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <!-- 資訊 -->
        <el-dialog title="商品資訊" :visible.sync="infoDia" fullscreen>
          <div>
            <el-row>
              <el-col :span="11">
                <div :style="{ overflow: 'hidden', width: `${140}px`, height: `${140}px`, backgroundImage: 'url(' + img + ')', backgroundSize: 'cover', backgroundPosition: 'center' }"></div>
              </el-col>
              <el-col :span="12">
                <div style="text-align: left; padding: 5px;">
                  <div style="font-weight: 500; color: black;">[商品名稱]</div>
                  <div>{{ itemTitle }}</div>
                  <div style="margin-top: 10px;">
                    <div style="font-weight: 500; color: black;">[兌換條件]</div>
                    <div style="font-weight: 400; width: 125px; display: inline-block;">所需點數: <span style="color: #409EFF; font-weight: 500;">{{ itemPoint }}</span></div>
                    <div style="font-weight: 400; width: 150px; display: inline-block;">所需等級: <span style="color: #409EFF; font-weight: 500;">{{ (itemLevel && itemLevel !== '無') ? itemLevel : '-' }}</span></div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <hr style="border: 0.5px solid #eee; width: 100%; margin: 5px auto;">
            <div :style="{ height: (shopHeight * 0.7) + 'px', overflow: 'auto', textAlign: 'left', paddingBottom: 80 + 'px', paddingTop: 10 + 'px' }">
              <div style="font-weight: 500; color: black">[商品內容]</div>
              <div v-for="(item, index) in detail.content" :key="index + 'c'">{{ item }}</div><br/>
              <div style="font-weight: 500; color: black;" v-if="detail.notice">[注意事項]</div>
              <div v-for="(item, index) in detail.notice" :key="index + 'n'">{{ item }}</div>
            </div>
          </div>
          <div style="width: 95%; padding: 8px; text-align: right; background-color: #fff; position: fixed; bottom: 70px;">
            <el-button @click="infoDia = false">返回</el-button>
            <el-button type="primary" @click="openDetail(itemAll)" :disabled="allowExchange(itemPoint) || requiredExp(itemLevel) > nowExp || outofUsage(itemAll) || notInTags(itemTags)">兌換</el-button>
          </div>
          <!-- <mu-button flat color="primary" slot="actions" @click="infoDia = false">返回</mu-button>
          <mu-button color="primary" slot="actions" @click="openDetail(itemAll)" :disabled="allowExchange(itemPoint) || requiredExp(itemLevel) > nowExp || outofUsage(itemAll) || notInTags(itemTags)">兌換</mu-button> -->
        </el-dialog>
        <!-- dialog -->
        <mu-dialog title="系統通知" width="100%" :open="dbcheckDia">
          <div>確認兌換: <span style="font-weight: 500; color: #333;">{{ discount.title }}</span></div>
          <div>花費點數: <span style="font-weight: 500; color: #333;">{{ discount.point }}</span></div>
          <div style="margin-top: 10px;">選擇門市:
            <span style="font-weight: 500; color: #333;">
              <mu-select v-model="selectedStore" style="width: 60%; max-width: 200px;">
                <mu-option v-for="(option, index) in Allstore" :key="index + 's'" :label="option" :value="option"></mu-option>
              </mu-select>
            </span>
          </div>
          <div v-if="discount.isCode === '2'">驗證碼:
            <span style="font-weight: 500; color: #333;">
              <mu-text-field style="width: 90%;" type="password" v-model="verCode" :error-text="errorMsg"></mu-text-field><br/>
            </span>
          </div>
          <!-- 備註 -->
          <el-input type="textarea"
            :rows="2"
            placeholder="請輸入備註"
            v-model="comment">
          </el-input>
          <!-- 備註 -->
          <mu-button slot="actions" color="primary" @click="sendExchange()">確認</mu-button>
          <mu-button slot="actions" flat color="primary" @click="dbcheckDia = false">取消</mu-button>
        </mu-dialog>
        <!-- loading -->
        <mu-dialog :open="loading" width="100%">
          <mu-linear-progress></mu-linear-progress>
        </mu-dialog>
        <!-- loading -->
        <!-- success -->
        <mu-dialog :open="successDia" width="100%">
          <div>兌換 <span style="font-weight: 500; color: #333;">{{ discount.title }}</span> 成功</div>
          <div>使用點數: {{ discount.point }}</div>
          <div>剩餘點數: {{ remainingpoint }}</div>
          <!-- <div>請點選下方連結完成兌換手續</div>
          <mu-button slot="actions" color="primary" @click="openUrl()">前往連結</mu-button> -->
          <mu-button slot="actions" flat color="primary" @click="closeDia">關閉</mu-button>
        </mu-dialog>
        <!-- success -->
        <FlashMessage></FlashMessage>
      </div>
      <div style="margin-top: 15px;" v-if="showBtn">
        <el-button type="danger" @click="pointDia = true" size="small">如何獲得點數?</el-button>
      </div>
      <mu-dialog title="獲得點數方式" :open="pointDia" width="80%" @close="pointDia = false">
        推薦好友加入會員，並且請他註冊時候在推薦碼填上您註冊的電話號碼，每推薦一個您和被推薦人都可以獲得點數，有任何問題可以 <a :href="customLink" target="blank">詢問LINE@客服</a>。<br><br>
        也可以傳送推薦連結給好友
        <mu-button slot="actions" color="primary" @click="doCopy">複製推薦連結</mu-button>
        <FlashMessage></FlashMessage>
      </mu-dialog>
      <!-- loading -->
      <mu-dialog :open="pageLoading" width="90%">
        <div style="text-align: center;">
          <mu-circular-progress class="demo-circular-progress" :size="36"></mu-circular-progress>
          <div>{{ loadingMsg }}</div>
        </div>
      </mu-dialog>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueClipboard from 'vue-clipboard2';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      detailDia: false,
      dbcheckDia: false,
      successDia: false,
      infoDia: false,
      remainingpoint: '',
      comment: '',
      loading: false,
      img: '',
      selectedStore: '',
      pageLoading: false,
      loadingMsg: '',
      Allstore: [],
      detail: {},
      itemAll: {},
      itemTitle: '',
      itemLevel: '',
      itemTags: [],
      itemPoint: 0,
      gifted: false,
      nowExp: 0,
      showBtn: false,
      pointDia: false,
      equal: true,
      verCode: '',
      discount: {},
      shopItems: [],
      // userItemCount: {}
    };
  },
  props: [
    'logo',
    'shopData',
    'store',
    'service',
    'auth',
    'token',
    'storeList', 
    'phone',
    'first',
    'only',
    'customLink',
    'memberUrl',
    'level',
    'exp',
    'userName',
    'shopHeight',
    'userTags'
  ],
  mounted() {
    this.nowExp = this.exp ? this.exp : 0;
    if (this.customLink && this.memberUrl) {
      this.showBtn = true;
    }
    if (this.first) {
      this.filterItems();
    } 
    else {
      this.gifted = false;
    }
    this.Allstore = Object.keys(this.storeList);
    this.getPoint(true);
  },
  computed: {
    ...mapGetters({
      userpoints: 'userpoints',
      userItemCount: 'userItemCount'
    }),
    userPointModel: {
      get() { return this.userpoints },
      set(value) { this.getPoints(value) }
    },
    userItemCountModel: {
      get() { return this.userItemCount },
      set(value) { this.getUserItem(value) }
    },
    errorMsg() {
      if (this.verCode === '') {
        return '請輸入驗證碼';
      }
      else if (this.discount.verCode.filter(el => el.store === this.selectedStore)[0].code === this.verCode) {
        return '';
      }
      else if (!this.equal) {
        return '驗證碼輸入錯誤';
      }
      return '';
    }
  },
  components: {
    VueClipboard,
  },
  methods: {
    ...mapMutations({
      getPoints  : 'getPoints',
      getUserItem: 'getUserItem'
    }),
    ...mapActions({
      checkUserFB           : 'checkUserFB',
      checkUserLINE         : 'checkUserLINE',
      checkLoginStatus      : 'checkLoginStatus',
      exchangePoint         : 'exchangePoint',
      userLoginGift         : 'userLoginGift',
      recalculateShopItemNum: 'recalculateShopItemNum',
      comsumeBroadcast      : 'comsumeBroadcast'
    }),
    col() {
      if (!this.logo || this.only) {
        return 24;
      }
      return 12;
    },
    doCopy() {
      this.$copyText(this.memberUrl);
      this.flashMessage.success({
        title: `Copied: ${this.memberUrl}`,
        time: 2000
      });
    },
    requiredExp(level) {
      if (this.level && level && level !== '無') {
        return this.level.filter(el => el.title === level)[0].exp;
      }
      return 0;
    },
    outofUsage(item) {
      if (item.redeem === '2') {
        if (this.userItemCountModel && this.userItemCountModel[item.title]) {
          if (parseInt(item.maxRedeem) - parseInt(this.userItemCountModel[item.title]) > 0) {
            return false;
          }
          else {
            return true;
          }
        }
        return false;
      }
      else {
        return false;
      }
    },
    filterItems() {
      this.checkLoginStatus({ service: this.service, auth: this.auth, phone: this.phone })
        .then((res) => {
          if (this.auth === '194224947256356' || this.auth === '1594896397' || this.auth === '1598025343' || this.auth === '434039813390955' || this.auth === '456983174723548' || this.auth === '418028101642254') {
            if (res.data && res.data.Status && res.data.Status.gifted) {
              const allItemNames = this.shopData.map(el => el.title);
              const giftIdx = allItemNames.indexOf('會員註冊禮(兌換請由店員操作)');
              this.shopData.splice(giftIdx, 1);
            }
            else {
              this.gifted = false;
            }
          }
        })
    },
    recalculateItemNum() {
      const postData = {
        service: this.service, phone: this.phone,
        name: this.userName, auth: this.auth,
        store: this.selectedStore, item: this.discount.title,
        remark: this.comment
      };
      this.recalculateShopItemNum(postData)
        .then(() => {
          this.getPoint(false);
        })
    },
    sendExchange() {
      if (!this.selectedStore || this.selectedStore === '') {
        return;
      }
      if (this.discount.isCode === '2' && (this.discount.verCode.filter(el => el.store === this.selectedStore)[0].code !== this.verCode)) {
        this.equal = false;
        return;
      }
      this.remainingpoint = parseInt(this.userPointModel) - parseInt(this.discount.point);
      this.loading = true;
      this.dbcheckDia = false;
      this.infoDia = false;
      // 兌點
      this.exchangePoint({ service: this.service, auth: this.auth, token: this.token, point: (this.discount.point === 0) ? '0' : this.discount.point, store: this.selectedStore })
        .then(() => {
          this.verCode = '';
          this.recalculateItemNum();
          if (this.discount.detail.reply) {
            const msg = this.discount.detail.reply.replace('$$title$$', this.discount.title).replace('$$discount$$', this.discount.point).replace('$$remaining$$', this.remainingpoint);
            this.comsumeBroadcast({ service: this.service, auth: this.auth, token: this.token, message: msg })
          }
          if (this.discount.title === '會員註冊禮(兌換請由店員操作)') {
            this.userLoginGift({ service: this.service, auth: this.auth, phone: this.phone })
              .then(() => {
                this.filterItems();
              });
          }
          this.loading = false;
          this.successDia = true;
          this.userPointModel = this.remainingpoint;
        });
    },
    closeDia() {
      this.successDia = false;
      this.detailDia = false;
    },
    notInTags(tags) {
      if (tags && tags.length > 0) {
        if (tags.indexOf('無限制') === -1) {
          if (this.userTags.length > 0) {
            const set1 = new Set(this.userTags);
            const set2 = new Set(tags);
            
            const result = this.userTags.filter((e)=>{
              return set2.has(e)
            })
            if (result.length > 0) {
              return false;
            }
            else {
              return true;
            }
          }
          else {
            return true;
          }
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    allowExchange(point) {
      if (this.userPointModel >= point) {
        return false;
      }
      return true;
    },
    restTime(name, max) {
      if (this.userItemCountModel && this.userItemCountModel[name]) {
        return max - parseInt(this.userItemCountModel[name]);
      }
      return max;
    },
    getPoint(boolean) {
      if (boolean) {
        this.pageLoading = true;
        this.loadingMsg  = '確認點數中';
      }
      if (this.service === 'LINE') {
        this.checkUserLINE({ ChannelID: this.auth, UserID: this.token })
          .then((res) => {
            this.pageLoading = false;
            this.userPointModel = res.data.Detail.Points;
            // 已購買品項
            if (res.data.Detail.buyItem) {
              this.userItemCountModel = res.data.Detail.buyItem;
            }
            else {
              this.userItemCountModel = {};
            }
          });
      }
      else {
        this.checkUserFB({ PageID: this.auth, PSID: this.token })
          .then((res) => {
            this.pageLoading = false;
            this.userPointModel = res.data.Detail.Points;
            // 已購買品項
            if (res.data.Detail.buyItem) {
              this.userItemCountModel = res.data.Detail.buyItem;
            }
            else {
              this.userItemCountModel = {};
            }
          });
      }
    },
    openDetail(item) {
      this.discount = item;
      this.img = item.imageUrl;
      this.detail = item.detail;
      this.Allstore = item.openStore ? item.openStore : this.Allstore;
      this.dbcheckDia = true;
    },
    openInfo(item) {
      this.itemAll   = item;
      this.itemTitle = item.title;
      this.itemLevel = item.level;
      this.itemPoint = item.point;
      this.itemTags  = (item.specificTag && item.specificTag.indexOf('無限制') === -1) ? item.specificTag : [];
      this.detail    = item.detail;
      this.img       = item.imageUrl;
      this.infoDia   = true;
    },
    openUrl() {
      window.open(`https://m.me/${this.auth}`);
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    },
    checkPush() {
      this.dbcheckDia = true;
    }
  }
}
</script>

<style scoped>
  #card {
    width: 100%;
    max-width: 550px;
    margin: -5px auto;
    overflow: hidden;
    border-radius: 5px;
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
    font-size: 13px;
  }
</style>